// Horizontal ranked bar list — magnitude (single hue) or categorical (per-row hue) data.
// Each row already carries its own text label + value, so identity never depends on color alone.
export default function BarList({ title, rows, footnote, labelWidth = 'w-28' }) {
  const max = Math.max(1, ...rows.map(r => r.value));

  return (
    <div className="rounded-xl border border-border2 bg-surface px-5 py-4">
      <div className="mb-4 text-sm font-bold">{title}</div>
      {rows.length === 0 ? (
        <div className="py-6 text-center text-xs text-muted">No data yet.</div>
      ) : (
        <div className="flex flex-col gap-3">
          {rows.map(row => (
            <div key={row.key} className="group flex items-center gap-3" title={`${row.label}: ${row.display}`}>
              <div className={`${labelWidth} shrink-0 truncate text-xs text-muted`}>{row.label}</div>
              <div className={`h-2 flex-1 overflow-hidden rounded-full ${row.track}`}>
                <div className={`h-full rounded-full transition-all duration-500 group-hover:brightness-125 ${row.color}`}
                  style={{ width: `${(row.value / max) * 100}%` }} />
              </div>
              <div className="w-16 shrink-0 text-right font-mono text-xs font-semibold text-ink">{row.display}</div>
            </div>
          ))}
        </div>
      )}
      {footnote && <div className="mt-3 text-[11px] text-dim">{footnote}</div>}
    </div>
  );
}
